












































































































import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'

import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import UserService from '@spa/services/api/user'
import store from '@spa/store'
import { User } from '@spa/store/modules/user/types'

Component.registerHooks([
  'beforeRouteEnter',
])

@Component({
  components: {
    SpaErrorDialog,
  },
})
export default class ResetPassword extends Mixins<PluginMixin>(PluginMixin) {
  status: Status = Status.Pending

  token: string | null = null

  messsage: string | null = null

  password: string | null = null

  passwordConfirm: string | null = null

  readonly STATUS_CODE_UNAUTHORIZED: number = 401

  showModal: boolean = false

  modalMessage: string = ''

  userService = new UserService()

  get user(): User {
    return this.$store.state.user.user
  }

  get isFailed(): boolean {
    return this.status === Status.Failed
  }

  get isCompleted(): boolean {
    return this.status === Status.Completed
  }

  async validateForm(): Promise<boolean> {
    return this.$validator.validateAll()
  }

  async beforeRouteEnter(to, _from, next) {
    store.dispatch('view/startLoading')

    // Check token

    const token = to.params.token

    if (!token) {
      this.modalMessage = 'パスワードを変更できませんでした。'
      this.showModal = true

      this.$store.dispatch('view/stopLoading')
      next('/login')

      return
    }

    next()
  }

  created() {
    this.token = this.$route.params.token

    this.$store.dispatch('view/stopLoading')
  }

  async submit() {
    const validated = await this.validateForm()

    if (!validated) {
      this.modalMessage = '入力内容が正しくありません。'
      this.showModal = true

      return
    }

    this.$store.dispatch('view/startLoading')

    const result = await this.userService.submitNewPassword(
      this.token!,
      this.password!,
      this.passwordConfirm!
    )

    if (result.isLeft()) {
      this.modalMessage = 'パスワードを変更できませんでした。'
      this.showModal = true
      this.status = Status.Failed
      this.$store.dispatch('view/stopLoading')

      return
    }

    this.status = Status.Completed
    this.$store.dispatch('view/stopLoading')

  }
}

enum Status {
  Pending,
  Loading,
  Failed,
  Completed,
}
